function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useRef, useEffect } from 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../../../hooks/useDocumentsAppConfigs.js";
import { observer } from 'mobx-react';
import _css from '@emotion/css';
import classnames from 'classnames';
import useStores from "../../../hooks/useStores.js";

var FillableCheckboxField = function FillableCheckboxField(_ref) {
  var selected = _ref.selected,
      field = _ref.field,
      disabled = _ref.disabled,
      onFocus = _ref.onFocus;
  var data = field.data;

  var _useState = useState(data.value || false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var bounding = useRef(null);

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var x = field.x,
      y = field.y,
      width = field.width,
      height = field.height;
  var bgColor = 'bg-primary';
  var borderColor = 'border-primary';
  var isUnassignedField = false;
  var highlightUnassignedFields = pdfStore.highlightUnassignedFields;
  disabled = disabled || pdfStore.signableOnly;

  if (!disabled) {
    isUnassignedField = !field.belongsTo(currentUserId, currentUserPermissions);

    if (highlightUnassignedFields) {
      bgColor = isUnassignedField ? 'bg-info' : 'bg-primary';
      borderColor = isUnassignedField ? 'border-info' : 'border-primary';
    } else {
      bgColor = isUnassignedField ? 'bg-transparent' : 'bg-primary';
      borderColor = isUnassignedField ? '' : 'border-primary';
    }
  }

  var fillable = !(disabled || isUnassignedField);
  useEffect(function () {
    if (selected) {
      bounding.current.focus();
    }
  }, [selected]);
  useEffect(function () {
    field.updateData({
      value: checked
    });
  }, [checked, field]);

  var toggleChecked = function toggleChecked() {
    if (fillable) {
      setChecked(!checked);
    }
  };

  var handleFocus = function handleFocus(e) {
    if (fillable) {
      onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }
  };

  return jsx("g", null, (isUnassignedField && highlightUnassignedFields || !disabled) && jsx("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    className: classnames(bgColor, _defineProperty({}, "".concat(borderColor), selected)),
    fillOpacity: bgColor === 'bg-info' ? 0.75 : 0.25
  }), jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height
  }, jsx("div", {
    tabIndex: 0,
    role: "checkbox",
    ref: bounding,
    className: classnames(['form-control', 'shadow-none', 'bg-transparent', 'border-0', 'd-flex align-items-center justify-content-center']),
    style: {
      width: width,
      height: height,
      padding: 1
    },
    onMouseDown: toggleChecked,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ') {
        // space key
        e.preventDefault();
        toggleChecked();
      }
    },
    onFocus: handleFocus,
    "data-testid": "checkbox",
    css:
    /*#__PURE__*/
    _css({
      cursor: fillable ? 'pointer' : ''
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    "aria-checked": !!checked
  }, checked && jsx("div", {
    className: "bg-dark h-100 w-100",
    "data-testid": "checked-square"
  }))));
};

FillableCheckboxField.displayName = "FillableCheckboxField";
var FillableCheckboxField$1 = observer(FillableCheckboxField);
export default FillableCheckboxField$1;